import { cn } from '@/lib/utils';

import { formFieldDisplayConfig } from './config';

type FieldErrorMessageProps = {
  message?: string | null;
  className?: string;
  reserveSpace?: boolean;
};

export const FieldErrorMessage = ({ message, className, reserveSpace }: FieldErrorMessageProps) => {
  const shouldReserveSpace = reserveSpace ?? formFieldDisplayConfig.reserveErrorMessageSpace;

  if (!message && !shouldReserveSpace) {
    return null;
  }

  return (
    <div
      aria-hidden={message ? undefined : true}
      className={cn(
        'mt-1 min-h-[18px] text-xs leading-[18px]',
        message ? 'text-red-500' : 'text-transparent',
        className
      )}
      data-testid="field-error-message"
      role={message ? 'alert' : undefined}
    >
      {message ?? '\u00A0'}
    </div>
  );
};
